import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Loading from "@client/controls/Loading/component";
import { Status, type WithIsEditMode } from "@client/types";
import * as React from "react";
import { type Form } from "../types";
import Content from "./Content/container";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    formId: string;
    form: Form.FormDetail | null;
    error: string | null;
    status: string;
  };

export type ActionProps = {
  loadDetail: (formId: string) => void;
};

type Props = ActionProps & MapProps;
export default (props: Props) => {
  React.useEffect(() => {
    if (props.formId) {
      props.loadDetail(props.formId);
    }
  }, [props.formId]);

  if (props.status === Status.None) return null;
  if (props.status === Status.Loading) return <Loading />;
  if (props.error) {
    return props.isEditMode ? <div>Failed to load the form: {props.error}</div> : null;
  }
  if (!props.form) return <div>This form isn't available</div>;

  return <Content {...getRootContainerProps(props)} formId={props.formId} />;
};
